/**
 * Escape a value for use in an iCalendar (RFC 5545) TEXT property such as
 * SUMMARY, LOCATION or DESCRIPTION. In TEXT values backslash, semicolon, comma
 * and newlines are structural and must be escaped, otherwise a location like
 * "Paris, France" splits LOCATION into multiple values and stricter calendar
 * apps reject or mis-import the .ics. Backslash must be escaped first.
 */
export function escapeICSText(value: string): string {
  return value
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\r\n|\r|\n/g, '\\n');
}
